(function () {
  function getTier(lbs) {
    if (!window.shippingTiers) return null;
    for (var i = 0; i < window.shippingTiers.length; i++) {
      // +0.01 tolerance absorbs grams→lbs floating point error (e.g. 10 lbs stored as
      // 4536g converts to 10.0007, which would otherwise miss the ≤10 tier boundary)
      if (lbs <= window.shippingTiers[i].max_lbs + 0.01) return window.shippingTiers[i];
    }
    return null;
  }

  function updateEl(el, totalGrams) {
    if (!el) return;
    if (!window.shippingTiers || !totalGrams) { el.style.display = 'none'; return; }

    var lbs = totalGrams / 453.592;
    var tier = getTier(lbs);
    if (tier === null) { el.style.display = 'none'; return; }

    var displayLbs = Math.round(lbs * 10) / 10;
    // Use rounded value so headroom is 0 when exactly at the tier max
    var headroom = Math.round((tier.max_lbs - displayLbs) * 10) / 10;

    var headroomText = '';
    if (tier.max_lbs < 99999 && headroom >= 0.1) {
      headroomText = ' <strong>Add up to ' + headroom + ' lbs</strong> to your order at no additional shipping cost.';
    }

    el.innerHTML =
      'Estimated shipping: $' + tier.rate +
      ' (based on ' + displayLbs + ' lbs).' + headroomText +
      ' <a href="/policies/shipping-policy" style="color:inherit;text-decoration:underline">see rates</a>';

    el.style.display = 'block';
  }

  // Disconnect before touching innerHTML, reconnect after — prevents the observer
  // from firing on its own update and creating an infinite loop.
  var drawerObserver = null;
  var cartDrawerEl = null;

  function updateDrawerEstimate() {
    if (drawerObserver) drawerObserver.disconnect();
    var input = document.getElementById('cart-drawer-total-grams');
    var el = document.getElementById('shipping-estimate-drawer');
    if (input && el) updateEl(el, parseInt(input.value, 10) || 0);
    if (drawerObserver && cartDrawerEl) drawerObserver.observe(cartDrawerEl, { childList: true, subtree: true });
  }

  // Cart page: initial render from hidden input
  var cartPageInput = document.getElementById('cart-total-grams');
  if (cartPageInput) updateEl(document.getElementById('shipping-estimate'), parseInt(cartPageInput.value, 10) || 0);

  document.addEventListener('DOMContentLoaded', function () {
    // Drawer: initial render from hidden input
    updateDrawerEstimate();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // Cart page: update when qty changes (pubsub fires with full cartData.items)
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || !event.cartData || !event.cartData.items) return;
        var totalGrams = event.cartData.items.reduce(function (sum, item) {
          return sum + (item.grams * item.quantity);
        }, 0);
        updateEl(document.getElementById('shipping-estimate'), totalGrams);
      });
    }

    // Drawer: update after any re-render via MutationObserver on #CartDrawer
    cartDrawerEl = document.getElementById('CartDrawer');
    if (cartDrawerEl) {
      drawerObserver = new MutationObserver(updateDrawerEstimate);
      drawerObserver.observe(cartDrawerEl, { childList: true, subtree: true });
    }
  });
})();
